export default "__VITE_ASSET__Byb4lNh5__"